import React, { useState } from "react";
import "./Css/uploadSystem.css";
import { toast } from "react-toastify";

export function SignaturePreview({ data }) {
  const [copied, setCopied] = useState(false);

  const copyToClipboard = async (event) => {
    if (event) event.preventDefault(); // Prevent default behavior if triggered from a button click

    const section = document.getElementById("previewArea");
    if (!section) return;

    const htmlContent = section.outerHTML; // Get the full HTML content

    try {
      // Use the modern Clipboard API to copy the HTML content
      await navigator.clipboard.write([
        new ClipboardItem({
          "text/html": new Blob([htmlContent], { type: "text/html" }),
        }),
      ]);

      // Show a preview of the copied HTML in another section
      const newHTMLSection = document.getElementById("newHTMLPreview");
      if (newHTMLSection) {
        newHTMLSection.innerHTML = htmlContent; // Render copied HTML as a preview
      }

      setCopied(true); // Update state to show success message
      toast.success("Copied Successfully.");
      setTimeout(() => setCopied(false), 3000); // Clear message after 3 seconds
    } catch (err) {
      console.error("Failed to copy:", err);
    }
  };

  // const copyToClipboard = (event) => {
  //   event.preventDefault();
  //   setCopied(true);

  //   const previewArea = document.getElementById("previewArea");
  //   if (!previewArea) return;
  //   const tempElement = document.createElement("div");
  //   tempElement.innerHTML = previewArea;
  //   document.body.appendChild(tempElement);

  //   const range = document.createRange();
  //   range.selectNodeContents(tempElement);

  //   const selection = window.getSelection();
  //   selection.removeAllRanges();
  //   selection.addRange(range);

  //   // Copy to clipboard
  //   document.execCommand("copy");
  //   selection.removeAllRanges();

  //   // Reset copied state after 3 seconds
  //   setTimeout(() => setCopied(false), 3000);
  // };

  const general = data.general ?? {};
  const contact = data.contacts ?? {};
  const socials = data.social ?? {};
  const emailSignature = data.emailSignature ?? {};
  console.log(data);
  return (
    <>
      <div
        style={{
          backgroundColor: "#00529c",
          color: "white",
          padding: "12px",
          width: "100%",
          borderTopLeftRadius: "10px",
          borderTopRightRadius: "10px",
          margin: "0",
        }}
      >
        <h2
          style={{
            fontSize: "1.25rem",
            fontWeight: "bold",
            textAlign: "center",
          }}
        >
          EMAIL SIGNATURE PREVIEW
        </h2>
      </div>
      <div style={{ backgroundColor: "white", padding: "12px" }}>
        <div class="signature">
          <body style={{ margin: "0", padding: "0", fontFamily: "Tahoma" }}>
            <div id="previewArea" style={{ color: "#004c98", width: "820px" }}>
              <p style={{ fontSize: "16px" }}>
                <b>
                  If you need any further information, please do not hesitate to
                  contact me.
                  <br />
                  Kind Regards,
                </b>
              </p>
              <br />
              <table
                style={{
                  width: "820px",
                  height: "155px",
                  backgroundImage: `url(${
                    emailSignature.banner ||
                    "https://es.multidynamic.com.au/images/new_banner-1.jpg"
                  })`,
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "120px center",
                }}
              >
                <tbody>
                  <tr style={{ margin: "0", padding: "0", width: "820px" }}>
                    <td style={{ width: "820px" }}>
                      <img
                        src={general.photo}
                        alt="Agent"
                        style={{
                          width: "130px",
                          maxWidth: "130px",
                          height: "130px",
                          display: "block",
                          border: "8px solid #f36421",
                          borderRadius: "50%",
                          boxSizing: "content-box",
                        }}
                      />
                    </td>
                  </tr>
                </tbody>
              </table>

              <table style={{ margin: "0", padding: "0", width: "820px" }}>
                <tbody style={{ width: "820px" }}>
                  <tr>
                    <td style={{ margin: "0", padding: "0", width: "410px" }}>
                      <h2
                        style={{
                          margin: "0",
                          padding: "0",
                          color: "#004c98",
                          fontWeight: "bold",
                          fontSize: "24px",
                        }}
                      >
                        {general.name}
                      </h2>
                      <p
                        style={{
                          margin: "0",
                          padding: "0",
                          fontStyle: "italic",
                          fontSize: "medium",
                          color: "#004c98",
                          fontWeight: "bold",
                        }}
                      >
                        {general.designation}
                      </p>
                      {general.branch && (
                        <h4 style={{ margin: "0", padding: "0" }}>
                          {general.branch}
                        </h4>
                      )}
                    </td>
                    <td
                      style={{
                        padding: "0",
                        width: "410px",
                        textAlign: "right",
                        whiteSpace: "nowrap", // Prevents wrapping
                      }}
                    >
                      {socials.facebook && (
                        <a
                          href={socials.facebook}
                          target="_blank"
                          rel="noreferrer"
                          style={{ display: "inline-block", margin: "2px" }}
                        >
                          <img
                            src="/images/facebook.jpg"
                            alt="facebook"
                            style={{
                              width: "30px",
                              height: "30px",
                              padding: "2px",
                            }}
                          />
                        </a>
                      )}
                      {socials.instagram && (
                        <a
                          href={socials.instagram}
                          target="_blank"
                          rel="noreferrer"
                          style={{ display: "inline-block", margin: "2px" }}
                        >
                          <img
                            src="/images/instagram.jpg"
                            alt="instagram"
                            style={{
                              width: "30px",
                              height: "30px",
                              padding: "2px",
                            }}
                          />
                        </a>
                      )}
                      {socials.linkedin && (
                        <a
                          href={socials.linkedin}
                          target="_blank"
                          rel="noreferrer"
                          style={{ display: "inline-block", margin: "2px" }}
                        >
                          <img
                            src="/images/linkedin.jpg"
                            alt="linkedin"
                            style={{
                              width: "30px",
                              height: "30px",
                              padding: "2px",
                            }}
                          />
                        </a>
                      )}
                      {socials.twitter && (
                        <a
                          href={socials.twitter}
                          target="_blank"
                          rel="noreferrer"
                          style={{ display: "inline-block", margin: "2px" }}
                        >
                          <img
                            src="/images/twitterx.jpg"
                            alt="twitter"
                            style={{
                              width: "30px",
                              height: "30px",
                              padding: "2px",
                            }}
                          />
                        </a>
                      )}
                      {socials.youtube && (
                        <a
                          href={socials.youtube}
                          target="_blank"
                          rel="noreferrer"
                          style={{ display: "inline-block", margin: "2px" }}
                        >
                          <img
                            src="/images/youtube.jpg"
                            alt="youtube"
                            style={{
                              width: "30px",
                              height: "30px",
                              padding: "2px",
                            }}
                          />
                        </a>
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>

              <table style={{ margin: "0", padding: "0", width: "820px" }}>
                <tbody>
                  <tr>
                    {/* Left side - Contact information */}
                    <td style={{ margin: "0", padding: "0", width: "50%" }}>
                      <table
                        style={{ margin: "0", padding: "0", width: "100%" }}
                      >
                        <tbody>
                          <tr>
                            <td
                              style={{
                                padding: "2px 5px 2px 0",
                                width: "30px",
                                height: "30px",
                                verticalAlign: "middle",
                              }}
                            >
                              <a
                                href={`tel:${contact.telephone}`}
                                target="_blank"
                                rel="noreferrer"
                              >
                                <img
                                  src="/images/phone.png"
                                  alt="phone"
                                  style={{
                                    width: "25px",
                                    height: "25px",
                                    display: "block",
                                    objectFit: "contain",
                                  }}
                                />
                              </a>
                            </td>
                            <td
                              style={{
                                fontSize: "14px",
                                verticalAlign: "middle",
                              }}
                            >
                              <a
                                href={`tel:${contact.telephone}`}
                                target="_blank"
                                rel="noreferrer"
                                style={{
                                  color: "#004c98",
                                  textDecoration: "none",
                                  marginRight: "5px",
                                }}
                              >
                                {contact.telephone}
                              </a>
                              {contact.telephone && contact.phone && " • "}
                              <a
                                href={`tel:${contact.phone}`}
                                target="_blank"
                                rel="noreferrer"
                                style={{
                                  color: "#004c98",
                                  textDecoration: "none",
                                  marginLeft: "5px",
                                }}
                              >
                                {contact.phone}
                              </a>
                            </td>
                          </tr>

                          <tr>
                            <td
                              style={{
                                padding: "2px 5px 2px 0",
                                width: "30px",
                                height: "30px",
                                verticalAlign: "middle",
                              }}
                            >
                              <a
                                href={`mailto:${contact.email}`}
                                target="_blank"
                                rel="noreferrer"
                              >
                                <img
                                  src="/images/email.png"
                                  alt="email"
                                  style={{
                                    width: "25px",
                                    height: "25px",
                                    display: "block",
                                    objectFit: "contain",
                                  }}
                                />
                              </a>
                            </td>
                            <td
                              style={{
                                fontSize: "14px",
                                verticalAlign: "middle",
                              }}
                            >
                              <a
                                href={`mailto:${contact.email}`}
                                target="_blank"
                                rel="noreferrer"
                                style={{
                                  color: "#004c98",
                                  textDecoration: "none",
                                }}
                              >
                                {contact.email}
                              </a>
                            </td>
                          </tr>

                          <tr>
                            <td
                              style={{
                                padding: "2px 5px 2px 0",
                                width: "30px",
                                height: "30px",
                                verticalAlign: "middle",
                              }}
                            >
                              <a
                                href={`${general.officeAddress}`}
                                target="_blank"
                                rel="noreferrer"
                              >
                                <img
                                  src="/images/location.png"
                                  alt="location"
                                  style={{
                                    width: "25px",
                                    height: "25px",
                                    display: "block",
                                    objectFit: "contain",
                                  }}
                                />
                              </a>
                            </td>
                            <td
                              style={{
                                fontSize: "14px",
                                verticalAlign: "middle",
                              }}
                            >
                              <a
                                href={`${general.officeAddress}`}
                                target="_blank"
                                rel="noreferrer"
                                style={{
                                  color: "#004c98",
                                  textDecoration: "none",
                                }}
                              >
                                {general.officeAddress}
                              </a>
                            </td>
                          </tr>

                          <tr>
                            <td
                              style={{
                                padding: "2px 5px 2px 0",
                                width: "30px",
                                height: "30px",
                                verticalAlign: "middle",
                              }}
                            >
                              <a
                                href={`${contact.website}`}
                                target="_blank"
                                rel="noreferrer"
                              >
                                <img
                                  src="/images/website.png"
                                  alt="website"
                                  style={{
                                    width: "25px",
                                    height: "25px",
                                    display: "block",
                                    objectFit: "contain",
                                  }}
                                />
                              </a>
                            </td>
                            <td
                              style={{
                                fontSize: "14px",
                                verticalAlign: "middle",
                              }}
                            >
                              <a
                                href={`${contact.website}`}
                                target="_blank"
                                rel="noreferrer"
                                style={{
                                  color: "#004c98",
                                  textDecoration: "none",
                                }}
                              >
                                {contact.website}
                              </a>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>

                    {/* Right side - Image */}
                    <td
                      style={{
                        margin: "0",
                        padding: "0",
                        textAlign: "right",
                        width: "100%",
                        overflow: "hidden",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                          whiteSpace: "nowrap", // Prevents images from stacking vertically
                          overflowX: "auto", // Enables horizontal scrolling if needed
                          gap: "10px",
                        }}
                      >
                        {general.awards.length > 0 ? (
                          general.awards.map((award, index) => (
                            <img
                              key={index}
                              src={award} // Award is a base64 string or URL of the image
                              alt={`award-${index}`}
                              style={{
                                width: "auto",
                                maxWidth: "100%", // Each image gets up to 30% of space
                                height: "120px", // Fixed height for uniformity
                                objectFit: "contain",
                                flexShrink: 0, // Prevents images from shrinking
                              }}
                            />
                          ))
                        ) : (
                          ""
                        )}
                        {emailSignature.awards.length > 0 ? (
                          emailSignature.awards.map((award, index) => (
                            <img
                              key={index}
                              src={award} // Award is a base64 string or URL of the image
                              alt={`award-${index}`}
                              style={{
                                width: "auto",
                                maxWidth: "100%", // Each image gets up to 30% of space
                                height: "120px", // Fixed height for uniformity
                                objectFit: "contain",
                                flexShrink: 0, // Prevents images from shrinking
                              }}
                            />
                          ))
                        ) : (
                          ""
                        )}
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>

              <div style={{ width: "820px" }}>
                <div
                  style={{
                    backgroundColor: "#f36d2d",
                    color: "white",
                    textAlign: "center",
                    paddingTop: "5px",
                  }}
                >
                  <div
                    style={{ backgroundColor: "#00529c", padding: "10px 0" }}
                  >
                    <p
                      style={{
                        margin: 0,
                        fontSize: "24px",
                        fontWeight: "bold",
                      }}
                    >
                      Your Dream Home Is Our Mission
                    </p>
                  </div>
                </div>
              </div>

              <p
                style={{
                  fontSize: "9px",
                  color: "#666666",
                  lineHeight: "100%",
                  margin: "0",
                  padding: "0",
                  width: "820px",
                }}
              >
                <b>Disclaimer:</b>
                This email is for its intended recipient only. If this email has
                been sent to you by error or contains private or confidential
                information, including the contact details of other persons,
                then you must not copy and distribute this information. Any
                views expressed in this email are those of the individual sender
                and may not necessarily reflect the views of Multi-Dynamic Pty
                Ltd. The sender believes this communication is free from any
                virus, worm, Trojan horse and/ or malicious code when sent. By
                reading this message and opening any attachments, the recipient
                accepts full responsibility for taking protective and remedial
                action as required.
                <br />
                <b>Privacy Policy:</b>
                <a
                  href="https://multidynamic.com.au/images/Privacy_policies.pdf"
                  style={{ color: "#004c98", textDecoration: "none" }}
                >
                  ClickHere
                </a>
              </p>
              <br />
              <p
                style={{
                  fontSize: "9px",
                  color: "#666666",
                  lineHeight: "100%",
                  margin: "0",
                  padding: "0",
                  width: "820px",
                }}
              >
                <b>We Value Your Feedback!</b>
                <br />
                <b>
                  Thank you for choosing us! We’d love to hear about your
                  experience. If you’d like to leave a review, please click the
                  link below and share your thoughts. Your feedback means the
                  world to us! ⭐⭐⭐⭐⭐
                </b>{" "}
                <br />
                <a
                  href="https://maps.app.goo.gl/CGSw8eTsrXviQkmP8?g_st=com.google.maps.preview.copy"
                  style={{ color: "#004c98", textDecoration: "none" }}
                >
                  Click Here to Leave a Review
                </a>
              </p>
            </div>
          </body>
        </div>
        {/* Click and Copy */}
        <div
          style={{
            textAlign: "center",
            marginTop: "16px",
            borderTop: "1px solid gray",
          }}
        >
          <button
            onClick={copyToClipboard}
            style={{
              padding: "10px 20px",
              border: "none",
              margin: "20px 0",
              backgroundColor: "#ec6620",
              color: "white",
              borderRadius: "5px",
              cursor: "pointer",
              fontSize: "24px",
              width: "100%",
            }}
          >
            {copied ? "Copied" : "Copy"}
          </button>
        </div>
      </div>
    </>
  );
}
